import { render, staticRenderFns } from "./CompetenceQualityCellRenderer.vue?vue&type=template&id=80441592&scoped=true&lang=pug&"
import script from "./CompetenceQualityCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./CompetenceQualityCellRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80441592",
  null
  
)

export default component.exports